﻿/**
 * Componente para alternar opcao
 * 
 * Exemplo: 
 * <bto-alternar alvo="$ctrl.ativo" />
 */


'use strict';

var centralApp = angular.module('app.components');


centralApp.component('btoAlternar', {
    controllerAs: '$ctrl',
    bindings: {
        alvo: '=',
        cache: '=?',
        manipulador: '&?'
    },
    transclude: true,
    controller: btoAlternarCtrl,
    template: [
        '<span class="text-muted pull-right">',
            '<i ng-click="$ctrl.alternar()" style="cursor: pointer;" class="fa" ng-class="{\'fa-toggle-on text-success\': $ctrl.alvo,\'fa-toggle-off\': !$ctrl.alvo}"></i> ',
            '<small ng-transclude></small>',
        '</span>'
    ].join('')
});

btoAlternarCtrl.$inject = ['$localStorage'];
function btoAlternarCtrl($localStorage) {
    var $ctrl = this;

    $ctrl.alternar = function () {

        $ctrl.alvo = !$ctrl.alvo;

        ($ctrl.manipulador || _.noop)({
            alvo: $ctrl.alvo
        });

    }
}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/bto-alternar/index.js
// module id = 308
// module chunks = 1